/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Delete_SuccessInputs */

const en_admin_invite_codes_delete_success = /** @type {(inputs: Admin_Invite_Codes_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invite code deleted`)
};

const zh_admin_invite_codes_delete_success = /** @type {(inputs: Admin_Invite_Codes_Delete_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邀请码已删除`)
};

/**
* | output |
* | --- |
* | "Invite code deleted" |
*
* @param {Admin_Invite_Codes_Delete_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_delete_success = /** @type {((inputs?: Admin_Invite_Codes_Delete_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Delete_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_delete_success(inputs)
	return zh_admin_invite_codes_delete_success(inputs)
});
export { admin_invite_codes_delete_success as "admin.invite_codes.delete_success" }